import { useEffect, useRef, useState } from 'react';

export const useReadMore = () => {
  const ref = useRef<HTMLElement>(null);
  const [readmeOpen, setReadmeOpen] = useState<boolean>(false);
  const [truncatable, setTruncatable] = useState<boolean>(false);

  useEffect(() => {
    const element = ref.current;

    if (!!element && !truncatable) {
      setTruncatable(
        // Added + 10 so it does not prematurely show the read more button
        element.offsetHeight + 10 < element.scrollHeight ||
          element.offsetWidth < element.scrollWidth,
      );
    }
  }, [ref, truncatable]);

  return { ref, readmeOpen, setReadmeOpen, truncatable };
};
